import cx from 'clsx';
import React from 'react';
import { useController } from 'react-hook-form';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const Component = ({
  id,
  value,
  onChange,
  error,
  tabsItems = [],
  label,
  itemKeys = { valueFieldKey: 'value', labelFieldKey: 'label' },
  variant,
  type,
  required,
  className = '',
}) => {
  const { t } = useTranslation();

  const { valueFieldKey, labelFieldKey } = itemKeys;

  return (
    <div className={cx(style.fieldWrapper, { [style.horizontalField]: variant === 'horizontal' }, className)}>
      {label && (
        <div
          className={cx(style.label, {
            [style.required]: required,
            [style.horizontalLabel]: variant === 'horizontal',
          })}
        >
          {label}
        </div>
      )}
      <div
        id={id}
        className={cx(style.tabsWrapper)}
        style={{
          gridTemplateColumns: `repeat(${tabsItems.length}, auto)`,
        }}
      >
        {tabsItems.map((option) => (
          <div
            key={option[valueFieldKey]}
            className={cx(style.itemBtn, {
              [style.itemBtnChecked]: option[valueFieldKey] === value,
              [style.itemBtnDisabled]: option.disabled,
            })}
            onClick={() => onChange(option[valueFieldKey])}
          >
            {option[labelFieldKey]}
          </div>
        ))}
      </div>
      {type !== 'woHelperText' && <div className={style.helperText}>{error && t(error?.message)}</div>}
    </div>
  );
};

const Controlled = ({
  name,
  id,
  control,
  variant,
  label,
  tabsItems = [],
  itemKeys,
  type,
  required,
  className,
}) => {
  const {
    field: { value, onChange },
    fieldState: { error },
  } = useController({
    control,
    name,
  });

  return (
    <Component
      id={id}
      value={value}
      onChange={onChange}
      error={error}
      tabsItems={tabsItems}
      label={label}
      itemKeys={itemKeys}
      variant={variant}
      type={type}
      required={required}
      className={className}
    />
  );
};

const Tabs = (props) => {
  return props.control ? <Controlled {...props} /> : <Component {...props} />;
};

export default Tabs;
